import React, { Component } from "react";
import { searchIcon } from "../../../utils/images";
import InputForm from "../../html/inputForm";
import SelectForm from "../../html/selectForm";
import IfscPopUp from "./ifscPopUp";
import KYCPopUp from "./kycPopUp";
import ModalPopUp from "../modalPopUp";
import commonContext, { AppContext } from "../../../context/common";
import { leadType } from "../../../../app";
import V from "../../../constents/validation";
import { Utilities } from "../../../utils/utilities";

interface IProps {}
interface IState {
    ifscPopUpSwitch: boolean;
    kycCompliantSwitch: boolean;
    kycCompliantAgree?: boolean;
}

export class BankDetailsForm extends Component<IProps, IState> {
    static contextType = commonContext;
    setLead: Function;
    lead: leadType;
    leadError: any;
    setLeadError: Function;
    utils: Utilities;
    constructor(props: IProps) {
        super(props);
        this.state = {
            ifscPopUpSwitch: false,
            kycCompliantSwitch: false,
            kycCompliantAgree: false,
        };
    }
    componentDidMount() {
        this.setLead = (this.context as AppContext).setLead;
        this.setLeadError = (this.context as AppContext).setLeadError;
    }
    render() {
        this.lead = (this.context as AppContext).lead as leadType;
        this.leadError = (this.context as AppContext).leadError;
        this.utils = (this.context as AppContext).utils as Utilities;
        return (
            <>
                <div className="relative w-full ifsc-wrap">
                    <p>
                        Your Bank account details as per bank statement
                        furnished by you are as under. However please note, the
                        disbursement if any, shall be made to the dealer /
                        seller of the vehicle.
                    </p>

                    <div className="relative w-full my-4">
                        <form>
                            <div className="flex flex-wrap w-full">
                                <div className="relative w-full sm:w-1/2 mb-3 pr-0 sm:pr-2 md:pr-4">
                                    <label className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base text-gray-500 ">
                                        IFSC Code
                                    </label>
                                    <div className="w-full relative">
                                        <span className="ifsc-search-icon">
                                            <img
                                                src={searchIcon}
                                                alt="Search"
                                                title="Search"
                                            />
                                        </span>
                                        <input
                                            type="text"
                                            onFocus={() =>
                                                this.setState({
                                                    ifscPopUpSwitch: true,
                                                })
                                            }
                                            value={this.lead.ifsc}
                                            className="mt-1 mb-4 sm:mb-4 md:mb-6 lg:mb-6 xl:mb-6 focus:ring-gray-500 focus:border-gray-500 block w-full text-base md:text-base lg:text-lg xl:text-xl border-gray-300 border-b-2 border-gray-200 pr-8 modal-open"
                                        />
                                    </div>
                                    <span
                                        className={
                                            !this.leadError["ifsc"]
                                                ? "hidden"
                                                : "" +
                                                  " error-msg text-red-600 openSans-Reg text-xs md:text-sm lg:text-sm xl:text-sm"
                                        }
                                    >
                                        {this.leadError["ifsc"]}
                                    </span>
                                </div>
                            </div>
                            <div className="flex flex-wrap w-full">
                                <div className="relative w-full sm:w-1/2 mb-3 pr-0 sm:pr-2 md:pr-4">
                                    <InputForm
                                        label="MICR Code"
                                        errorText="Please enter MICR code"
                                        value={this.lead.micrCode}
                                        readonly={true}
                                    />
                                </div>
                                <div className="relative w-full sm:w-1/2 mb-3 pl-0 sm:pl-2 md:pl-4">
                                    <InputForm
                                        label="Bank Name"
                                        errorText="Please enter Bank Name"
                                        value={this.lead.bankName}
                                        readonly={true}
                                    />
                                </div>

                                <div className="relative w-full sm:w-1/2 mb-3 pr-0 sm:pr-2 md:pr-4">
                                    <InputForm
                                        label="Bank Account No"
                                        errorText="Please enter bank account number"
                                        value={this.lead.bankAccount}
                                        readonly={true}
                                    />
                                </div>

                                <div className="relative w-full sm:w-1/2 mb-3 pl-0 sm:pl-2 md:pl-4">
                                    <InputForm
                                        label="Branch Name"
                                        errorText="Please enter branch Name"
                                        value={this.lead.bankBranchName}
                                        readonly={true}
                                    />
                                </div>

                                <div className="relative w-full sm:w-1/2 mb-3 pr-0 sm:pr-2 md:pr-4">
                                    <SelectForm
                                        title="Bank Account Types"
                                        noneText="Select Bank Account Types"
                                        errorText="Please select bank account types"
                                        name="bankAccountType"
                                        options={[
                                            { bankAccountType: "savings" },
                                            { bankAccountType: "current" },
                                        ]}
                                        handlerOnChange={async () =>
                                            await this.setLeadError(
                                                this.utils.formValidation(
                                                    {
                                                        ...this.lead,
                                                    },
                                                    [V.bankAccountType]
                                                )
                                            )
                                        }
                                        value={this.lead.accountType}
                                    />
                                </div>

                                <div className="relative w-full">
                                    <div className="mb-2 text-left">
                                        <label className="custom-inputs inline-flex items-start md:items-center">
                                            <input
                                                type="checkbox"
                                                onClick={(e) => {
                                                    this.setLead({
                                                        kycCompliantAgree: !this
                                                            .state
                                                            .kycCompliantAgree,
                                                    });
                                                    this.setState({
                                                        kycCompliantAgree: !this
                                                            .state
                                                            .kycCompliantAgree,
                                                    });
                                                }}
                                                checked={
                                                    this.lead.kycCompliantAgree
                                                }
                                            />
                                            <span></span>
                                            <span
                                                className="ml-2 text-sm md:text-base lg:text-xl text-black openSans-Reg modal-open"
                                                onClick={() =>
                                                    this.setState({
                                                        kycCompliantSwitch: true,
                                                    })
                                                }
                                            >
                                                I Confirm that the above account
                                                is fully KYC compliant with the
                                                above bank.
                                            </span>
                                        </label>
                                    </div>
                                    <span
                                        className={
                                            !this.leadError["kycCompliantAgree"]
                                                ? "hidden"
                                                : "" +
                                                  " error-msg-relative text-red-600 openSans-Reg text-xs md:text-sm lg:text-sm xl:text-sm"
                                        }
                                    >
                                        {this.leadError["kycCompliantAgree"]}
                                    </span>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                {this.state.ifscPopUpSwitch ? (
                    <IfscPopUp
                        onclickhandler={() =>
                            this.setState({
                                ifscPopUpSwitch: false,
                            })
                        }
                    />
                ) : (
                    ""
                )}

                {this.state.kycCompliantSwitch ? (
                    <ModalPopUp
                        onclickhandler={() => {
                            this.setState({
                                kycCompliantSwitch: false,
                            });
                        }}
                    >
                        <KYCPopUp
                            onclickhandler={(e) => {
                                e.preventDefault();
                                this.setState({
                                    kycCompliantSwitch: false,
                                });
                                this.setLead({
                                    kycCompliantAgree: !this.state
                                        .kycCompliantAgree,
                                });
                                this.setLeadError({ kycCompliantAgree: "" });
                            }}
                        />
                    </ModalPopUp>
                ) : (
                    ""
                )}
            </>
        );
    }
}

export default BankDetailsForm;
